import React,{ChangeEvent,useContext, useState} from 'react'
import Layout from '../layout/Layout'
import AuthContainer from '../features/authentication/components/AuthContainer'
import Button from '../component/Button'
import Input from '../component/Input'
import { UserContext } from '../context/userContext'
import axios from 'axios'
import {toast} from 'react-toastify';
import { isConfirmPassword, isEmailValid, isPasswordValid, isUsernameValid } from '../util/middleware'

function SignUpPage() {
  const {user} = useContext(UserContext);

   // ERRORS
   const [emailError, setEmailError] = useState<string>("");
   const [passwordError, setPasswordError] = useState<string>("");
   const [confirmPasswordError, setConfirmPasswordError] = useState<string>("");
   const [usernameError,setUsernameError] = useState<string>('')

   
  type authUser = {email:string,password:string,confirmPassword:string,username:string}
  const [userInput,setUserInput] = useState<authUser>({'email':'','password':'','confirmPassword':'','username':''})
  const {email,password,confirmPassword,username} = userInput;

  const validateEmail = (value:string) => {
    let emailRes:(boolean|string)[] = isEmailValid(value);
    let isValidEmail:(boolean|string) =emailRes[0] ? emailRes[1] : "" 
    setEmailError(isValidEmail as string);
  };

  const validatePassword = (value:string) => {
    let paswdRes:(boolean|string)[]= isPasswordValid(value);
    let isValidPassword:(boolean|string)  = paswdRes[0] ? paswdRes[1] : "";
    setPasswordError(isValidPassword as string);
  };
  const validateConfirmPassword = (value:{password:string,confirmPassword:string}) => {
    let cfRes:(boolean|string)[]= isConfirmPassword(value);
    let isValidPassword:(boolean|string)  = cfRes[0] ? cfRes[1] : "";
    setConfirmPasswordError(isValidPassword as string);
  };

  const validateUsername = (value:string) => {
    let emailRes:(boolean|string)[] = isUsernameValid(value);
    let isValidEmail:(boolean|string) =emailRes[0] ? emailRes[1] : "" 
    setUsernameError(isValidEmail as string);
  };

  const handleChange = (e:ChangeEvent<HTMLInputElement>) => {
    // console.log('===============changing=============');
      e.preventDefault();
      const { value, id} = e.target;

      setUserInput((prev: authUser)=>({...prev,[id]:value}))  
      if(id==='email'){
        validateEmail(value);
      }
      else if(id==='password'){
        validatePassword(value);
      } 
      else if(id==='username'){
        validateUsername(value);
      }
      else{
        validateConfirmPassword({'password':password,'confirmPassword':value})
      } 

      }

      const handleSignUp = async() =>{
        // e.preventDefault()
        // console.log('==============signing up===========',user.accessToken);
            try {
              const header = {
                'headers':{
                  'Authorization':`Bearer ${user.accessToken}`
                }
              }

                const newData:authUser = {email,password,confirmPassword,username}
                // Get Access to Signer
                // Make Function Call
                const response =await axios.post(`${process.env.REACT_APP_BASE_URL}/auth/createUser`,newData,header);
                if(response.status ===201){
                
                reset();
                
                toast.success("User Created!", {
                    position: toast.POSITION.TOP_CENTER
                  });
                }
                else{
                    toast.error("Couldn't create User,contact Admin!", {
                        position: toast.POSITION.TOP_CENTER
                      });
                }
                
            } catch (error) {
                toast.error(`${(error as any).message}`, {
                    position: toast.POSITION.TOP_LEFT
                  });                
                // console.log('My Error',error);
            }       
}

const reset = ()=>{
  setUserInput({'email':'','password':'','confirmPassword':'','username':''});
}

  return (
    <div className='h-screen w-full'>
    <Layout>
    <AuthContainer>
    <h1 className='font-bold text-center' >Create Publisher Account</h1>    
    <p className='text-left mt-1'>Username:</p>
    {usernameError && <p className='text-red-500' >{usernameError}</p>}
    <Input type={'text'} name={'username'} id={'username'} placeholder={'Enter username'} value={username} onChange={handleChange}/>    
    <p className='text-left mt-1'>Email:</p>
    {emailError && <p className='text-red-500' >{emailError}</p>}
    <Input type={'text'} name={'email'} id={'email'} placeholder={'Enter email'} value={email} onChange={handleChange}/>
    <p className='mt-1' >Password:</p>
    {passwordError && <p className='text-red-500' >{passwordError}</p>}
    <Input type={'password'} name={'password'} id={'password'} placeholder={'Enter password'} value={password} onChange={handleChange}></Input>
    <p className='mt-1' >Confirm Password:</p>
    {confirmPasswordError && <p className='text-red-500' >{confirmPasswordError}</p>}
    <Input type={'password'} name={'confirmPassword'} id={'confirmPassword'} placeholder={'Enter password'} value={confirmPassword} onChange={handleChange}></Input>
    <span className='mt-4'></span>
    <Button label={'Create Account'} onClick={()=>!usernameError&&!emailError&&!passwordError&&!confirmPasswordError?handleSignUp():null}></Button>

    </AuthContainer>
    </Layout>
  </div>
  )
}

export default SignUpPage